/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Tue Nov 19 2024
 **/

import { _P } from "@rfice/language";
import { Avatar } from "frameworks/core/components";

import { Column, Typography } from "@/frameworks/designStuff";
import { usePersistActions } from "@/frameworks/core/persistence";

export default function KnockConfirm({ userID }: { userID: string }) {
	const { users } = usePersistActions();
	const userName = users.get_user(userID)?.name;

	return (
		<Column horizonAlign="center" verticalAlign="center" gap={16} style={{ width: "100%" }}>
			<Avatar id={userID} kind="people_80" showMiniProfile={false} />
			<Typography typoColor="neutral_70_100" typoSize="Title2" align="center">
				{_P("{{userName}}님이 잠시 다른 용무 중입니다. <br/>깨우시겠습니까?", { userName })}
			</Typography>
		</Column>
	);
}
